var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowsAltV = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.9607 5.52297C15.6678 5.81586 15.1929 5.81586 14.9 5.52297L11.991 2.61394L11.991 9.7326C11.991 10.1468 11.6552 10.4826 11.241 10.4826C10.8267 10.4826 10.491 10.1468 10.491 9.7326L10.491 2.50738L7.47537 5.52297C7.18248 5.81586 6.7076 5.81586 6.41471 5.52297C6.12182 5.23008 6.12182 4.7552 6.41471 4.46231L10.6573 0.219669C10.9502 -0.0732252 11.4251 -0.0732252 11.718 0.219669L15.9607 4.46231C16.2535 4.7552 16.2535 5.23008 15.9607 5.52297ZM6.52127 18.4422C6.81416 18.1493 7.28903 18.1493 7.58193 18.4422L10.491 21.3513L10.491 14.2326C10.491 13.8184 10.8267 13.4826 11.241 13.4826C11.6552 13.4826 11.991 13.8184 11.991 14.2326L11.991 21.4578L15.0065 18.4422C15.2994 18.1493 15.7743 18.1493 16.0672 18.4422C16.3601 18.7351 16.3601 19.21 16.0672 19.5029L11.8246 23.7455C11.5317 24.0384 11.0568 24.0384 10.7639 23.7455L6.52127 19.5029C6.22837 19.21 6.22837 18.7351 6.52127 18.4422Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowsAltV);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrows-alt-v.f2f91becde0aafdbd5dcbcbd46a89621.svg";